// Configuration Firebase
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCYD7MJ2KWAITWo5Yv0MhBZuYOcBp52CVU",
  authDomain: "ia-watch-1d58d.firebaseapp.com",
  projectId: "ia-watch-1d58d",
  storageBucket: "ia-watch-1d58d.appspot.com",
  messagingSenderId: "122785368596",
  appId: "1:122785368596:web:4c5db3a2852a3346971fa1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export default app;